import React from 'react'

export default function OrderPlaceIcon({ flex = 'none' }) {
    return (
        <svg style={{width:"20px", height:"15px", flex}} viewBox="0 0 20 20" fill="none"  xmlns="http://www.w3.org/2000/svg"  stroke="#006400" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 6h15l-1.5 9h-13L4 4H1" />
            <circle cx="9" cy="20" r="1" />
            <circle cx="18" cy="20" r="1" />
            <circle cx="17" cy="6" r="5" fill="#e6f4ea" stroke="#006400" strokeWidth="2" />
            <path d="M15.5 6.5l1.5 1.5 3-3" stroke="#006400" strokeWidth="2" fill="none" />
        </svg>
    )
}
